// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   SUPPORT & HELP CENTER STYLES
   ========================================================================== */

.support-kpi-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 12px;
    margin-bottom: 16px;
}

.support-kpi-card {
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-md);
    padding: 14px 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    box-shadow: var(--shadow-subtle);
    transition: all 0.2s ease;
}

.support-kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-card);
    border-color: #cbd5e1;
}

.support-kpi-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
}

.icon-purple-soft {
    background: #eef2ff;
    color: #4f46e5;
}

.icon-amber-soft {
    background: #fffbeb;
    color: #d97706;
}

.icon-emerald-soft {
    background: #ecfdf5;
    color: #059669;
}

.icon-sky-soft {
    background: #f0f9ff;
    color: #0284c7;
}

.support-kpi-content {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.support-kpi-label {
    font-size: 11.5px;
    font-weight: 600;
    color: var(--text-muted);
    margin-bottom: 2px;
}

.support-kpi-val {
    font-family: var(--font-heading);
    font-size: 20px;
    font-weight: 800;
    color: var(--text-heading);
    line-height: 1.1;
}

.support-kpi-sub {
    font-size: 10.5px;
    color: var(--text-light);
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* Primary Action Button */
.btn-create-ticket-primary {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 8px 16px;
    background: linear-gradient(135deg, var(--brand-primary), #4338ca);
    color: #ffffff;
    border: none;
    border-radius: var(--radius-md);
    font-family: var(--font-heading);
    font-size: 12.5px;
    font-weight: 700;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    white-space: nowrap;
}

.btn-create-ticket-primary:hover {
    background: linear-gradient(135deg, #4f46e5, #3730a3);
    box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
    transform: translateY(-1px);
    color: #ffffff;
}

.btn-create-ticket-primary i {
    font-size: 14px;
}

/* Support Tickets Table Card */
.support-tickets-card {
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-card);
    overflow: visible;
    display: flex;
    flex-direction: column;
}

.support-tickets-card .pro-card-header {
    padding: 14px 18px;
    background: #ffffff;
    border-bottom: 1px solid var(--surface-border-subtle);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    position: relative;
    z-index: 20;
}

.card-header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.support-search-wrap {
    position: relative;
    width: 175px;
}

.support-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #94a3b8;
    font-size: 12px;
    pointer-events: none;
}

.support-search-input {
    width: 100%;
    height: 32px;
    padding: 4px 10px 4px 30px;
    font-size: 12px;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    background: #f8fafc;
    color: var(--text-heading);
    outline: none;
    transition: all 0.2s ease;
}

.support-search-input:focus {
    background: #ffffff;
    border-color: var(--brand-primary);
    box-shadow: 0 0 0 2px var(--brand-primary-glow);
}

/* Custom Popover Dropdowns */
.custom-popover-dropdown {
    position: relative;
}

.custom-dropdown-btn {
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    height: 32px;
    padding: 0 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
}

.custom-dropdown-btn:hover,
.custom-dropdown-btn.active {
    background: #ffffff;
    border-color: var(--brand-primary);
    box-shadow: 0 0 0 2px var(--brand-primary-glow);
    color: var(--brand-primary);
}

.custom-dropdown-btn i.chevron {
    font-size: 10px;
    color: #94a3b8;
    transition: transform 0.2s ease;
}

.custom-dropdown-btn.active i.chevron {
    transform: rotate(180deg);
    color: var(--brand-primary);
}

.custom-dropdown-popover {
    position: absolute;
    top: calc(100% + 5px);
    right: 0;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 8px 10px -6px rgba(15, 23, 42, 0.05);
    padding: 5px;
    min-width: 160px;
    z-index: 120;
    animation: dropdownFadeSlide 0.16s cubic-bezier(0.16, 1, 0.3, 1);
}

.custom-popover-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 7px 10px;
    border-radius: 5px;
    font-size: 12px;
    font-weight: 500;
    color: #334155;
    cursor: pointer;
    transition: all 0.12s ease;
}

.custom-popover-item:hover {
    background: #f1f5f9;
    color: var(--brand-primary);
}

.custom-popover-item.selected {
    background: #eef2ff;
    color: #4f46e5;
    font-weight: 600;
}

.item-left-content {
    display: flex;
    align-items: center;
    gap: 7px;
}

.item-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
}

/* Date Range Popover Specifics */
.date-range-popover {
    min-width: 290px;
    padding: 12px 14px;
}

.date-preset-pills {
    display: flex;
    gap: 6px;
    flex-wrap: wrap;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f5f9;
}

.btn-preset-pill {
    padding: 3px 8px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    font-size: 10.5px;
    font-weight: 600;
    color: #475569;
    cursor: pointer;
    transition: all 0.15s ease;
}

.btn-preset-pill:hover,
.btn-preset-pill.active {
    background: #4f46e5;
    border-color: #4f46e5;
    color: #ffffff;
}

.date-inputs-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
}

.date-input-group {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.date-input-group label {
    font-size: 10.5px;
    font-weight: 700;
    color: #64748b;
    margin: 0;
}

.date-input-field {
    width: 100%;
    height: 30px;
    padding: 2px 6px;
    font-size: 11.5px;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    outline: none;
    color: #1e293b;
    background: #f8fafc;
}

.date-input-field:focus {
    background: #ffffff;
    border-color: var(--brand-primary);
}

.date-popover-footer {
    display: flex;
    justify-content: flex-end;
    gap: 6px;
}

.btn-date-clear {
    padding: 4px 10px;
    font-size: 11px;
    font-weight: 600;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 5px;
    color: #64748b;
    cursor: pointer;
}

.btn-date-apply {
    padding: 4px 12px;
    font-size: 11px;
    font-weight: 700;
    background: var(--brand-primary);
    border: 1px solid var(--brand-primary);
    border-radius: 5px;
    color: #ffffff;
    cursor: pointer;
}

.btn-clear-filters {
    height: 32px;
    padding: 0 10px;
    font-size: 11.5px;
    font-weight: 600;
    border: 1px dashed #cbd5e1;
    border-radius: 6px;
    background: #ffffff;
    color: #64748b;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.btn-clear-filters:hover {
    background: #fef2f2;
    color: #ef4444;
    border-color: #fecaca;
}

/* Table Specific Rules */
.support-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12px;
    height: auto !important;
    flex: none !important;
}

.support-table thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    padding: 10px 14px;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
}

.support-table tbody tr {
    transition: background-color 0.15s ease;
    border-bottom: 1px solid #f1f5f9;
    cursor: pointer;
}

.support-table tbody tr:last-child {
    border-bottom: none;
}

.support-table tbody tr:hover {
    background-color: #f1f5f9;
}

.support-table td {
    padding: 12px 14px;
    vertical-align: middle;
}

.cell-index-badge {
    font-size: 11px;
    font-weight: 700;
    color: #94a3b8;
    font-family: var(--font-mono);
}

.ticket-title-link {
    color: #1e293b;
    font-weight: 700;
    font-size: 13px;
    text-decoration: none;
    cursor: pointer;
    display: inline-block;
    margin-bottom: 3px;
    transition: color 0.15s ease;
}

.ticket-title-link:hover {
    color: var(--brand-primary);
}

.ticket-desc-snippet {
    font-size: 11.5px;
    color: #64748b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 380px;
    line-height: 1.3;
}

.project-tag-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 9px;
    border-radius: var(--radius-full);
    font-size: 11px;
    font-weight: 600;
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #dbeafe;
    white-space: nowrap;
}

.category-tag-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 9px;
    border-radius: var(--radius-full);
    font-size: 11px;
    font-weight: 600;
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #e2e8f0;
    text-transform: capitalize;
    white-space: nowrap;
}

.priority-badge-pill {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 9px;
    border-radius: var(--radius-full);
    font-size: 11px;
    font-weight: 700;
    text-transform: capitalize;
    white-space: nowrap;
}

.priority-urgent,
.priority-high {
    background: #fef2f2;
    color: #dc2626;
    border: 1px solid #fecaca;
}

.priority-medium {
    background: #fffbeb;
    color: #d97706;
    border: 1px solid #fde68a;
}

.priority-low {
    background: #f0fdf4;
    color: #16a34a;
    border: 1px solid #bbf7d0;
}

.ticket-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 3px 10px;
    border-radius: var(--radius-full);
    font-size: 11px;
    font-weight: 700;
    text-transform: capitalize;
    white-space: nowrap;
}

.status-resolved,
.status-closed {
    background: #ecfdf5;
    color: #059669;
    border: 1px solid #a7f3d0;
}

.status-in_progress {
    background: #fffbeb;
    color: #d97706;
    border: 1px solid #fde68a;
}

.status-open {
    background: #eef2ff;
    color: #4f46e5;
    border: 1px solid #c7d2fe;
}

.status-dot-sm {
    width: 6px;
    height: 6px;
    border-radius: 50%;
}

.status-resolved .status-dot-sm,
.status-closed .status-dot-sm {
    background-color: #059669;
}

.status-in_progress .status-dot-sm {
    background-color: #d97706;
}

.status-open .status-dot-sm {
    background-color: #4f46e5;
}

.ticket-screenshots-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 600;
    background: #f8fafc;
    border: 1px solid #cbd5e1;
    color: #334155;
    cursor: pointer;
    transition: all 0.15s ease;
    white-space: nowrap;
}

.ticket-screenshots-badge:hover {
    background: #e2e8f0;
    color: #0f172a;
    border-color: #94a3b8;
}

/* Action Buttons */
.action-btn-group {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    margin: 0;
    padding: 0;
}

.action-btn-group button {
    margin: 0 !important;
}

.btn-action-icon {
    width: 24px;
    height: 24px;
    padding: 0;
    border-radius: 4px;
    border: none;
    background: transparent;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
    line-height: 1;
}

.btn-action-icon:hover {
    transform: translateY(-1px);
}

.btn-action-icon.btn-edit:hover {
    background: #fffbeb;
    color: #d97706;
}

.btn-action-icon.btn-delete:hover {
    background: #fef2f2;
    color: #ef4444;
}

.btn-action-view-chat {
    width: 24px;
    height: 24px;
    padding: 0;
    border: none;
    background: transparent;
    color: #2563eb;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    border-radius: 4px;
    transition: all 0.15s ease;
    line-height: 1;
}

.btn-action-view-chat:hover {
    background: #eff6ff;
    color: #1d4ed8;
    transform: translateY(-1px);
    border: none;
}

.btn-action-view-chat.has-unread {
    border: none;
    background: transparent;
    color: #2563eb;
}

.btn-action-view-chat.has-unread:hover {
    background: #eff6ff;
    color: #1d4ed8;
    border: none;
}

.client-action-unread-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 15px;
    height: 15px;
    padding: 0 2px;
    border-radius: 999px;
    background: #ef4444;
    color: #ffffff;
    font-size: 0.62rem;
    font-weight: 700;
    line-height: 1;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.45);
    animation: unreadPulse 2s infinite ease-in-out;
    pointer-events: none;
    z-index: 2;
}

@keyframes unreadPulse {
    0%, 100% {
        transform: scale(1);
        box-shadow: 0 2px 4px rgba(239, 68, 68, 0.45);
    }
    50% {
        transform: scale(1.1);
        box-shadow: 0 3px 8px rgba(239, 68, 68, 0.65);
    }
}

.client-row-has-unread {
    background-color: rgba(254, 242, 242, 0.45) !important;
}

.client-row-has-unread:hover {
    background-color: rgba(254, 226, 226, 0.65) !important;
}

.client-unread-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #ef4444;
    margin-right: 6px;
    box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
}

/* Empty State */
.support-empty-state {
    padding: 48px 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.support-empty-icon-wrap {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    color: var(--brand-primary);
    margin-bottom: 12px;
}

.support-empty-title {
    font-family: var(--font-heading);
    font-size: 15px;
    font-weight: 700;
    color: var(--text-heading);
    margin-bottom: 4px;
}

.support-empty-desc {
    font-size: 12px;
    color: var(--text-muted);
    max-width: 360px;
    margin-bottom: 16px;
}

/* Modal Form Styles */
.custom-support-modal .modal-content {
    border: 1px solid var(--surface-border);
    border-radius: 14px;
    box-shadow: 0 20px 35px -10px rgba(15, 23, 42, 0.2);
    overflow: hidden;
}

.custom-support-modal .modal-header {
    background: #fafbfc;
    border-bottom: 1px solid var(--surface-border-subtle);
    padding: 14px 20px;
}

.custom-support-modal .modal-title {
    font-family: var(--font-heading);
    font-size: 15px;
    font-weight: 800;
    color: var(--text-heading);
}

.custom-support-modal .modal-body {
    padding: 20px;
}

.modal-form-label {
    font-size: 11.5px;
    font-weight: 700;
    color: var(--text-heading);
    margin-bottom: 5px;
    display: block;
}

.modal-form-control,
.modal-form-select {
    width: 100%;
    padding: 8px 12px;
    font-size: 12.5px;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-sm);
    background: #ffffff;
    color: var(--text-heading);
    transition: all 0.2s ease;
    outline: none;
}

.modal-form-control:focus,
.modal-form-select:focus {
    border-color: var(--brand-primary);
    box-shadow: 0 0 0 3px var(--brand-primary-glow);
}

/* Upload Box */
.screenshot-upload-dropzone {
    border: 2px dashed #cbd5e1;
    border-radius: var(--radius-md);
    padding: 16px 14px;
    text-align: center;
    background: #f8fafc;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
}

.screenshot-upload-dropzone:hover {
    border-color: var(--brand-primary);
    background: #f1f5f9;
}

.upload-icon-circle {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #e0e7ff;
    color: var(--brand-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin: 0 auto 8px auto;
}

.upload-hint-main {
    font-size: 12px;
    font-weight: 700;
    color: var(--text-heading);
}

.upload-hint-sub {
    font-size: 10.5px;
    color: var(--text-muted);
}

/* Screenshot Preview Strip */
.screenshot-preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
    gap: 8px;
    margin-top: 10px;
}

.screenshot-thumb-wrap {
    position: relative;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    overflow: hidden;
    height: 75px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
}

.screenshot-thumb-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.btn-remove-thumb {
    position: absolute;
    top: 3px;
    right: 3px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: rgba(239, 68, 68, 0.9);
    color: white;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    cursor: pointer;
    transition: transform 0.15s ease;
}

.btn-remove-thumb:hover {
    transform: scale(1.15);
}

.custom-support-modal .modal-footer {
    background: #fafbfc;
    border-top: 1px solid var(--surface-border-subtle);
    padding: 12px 20px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
}

.btn-modal-cancel {
    padding: 7px 14px;
    background: #ffffff;
    border: 1px solid var(--surface-border);
    border-radius: var(--radius-sm);
    font-size: 12px;
    font-weight: 600;
    color: var(--text-body);
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-modal-cancel:hover {
    background: var(--surface-subtle);
}

.btn-modal-submit {
    padding: 7px 16px;
    background: var(--brand-primary);
    border: 1px solid var(--brand-primary);
    border-radius: var(--radius-sm);
    font-size: 12px;
    font-weight: 700;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-modal-submit:hover {
    background: #4338ca;
}

.btn-modal-submit:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

.btn-modal-delete {
    padding: 7px 16px;
    background: #ef4444;
    border: 1px solid #ef4444;
    border-radius: var(--radius-sm);
    font-size: 12px;
    font-weight: 700;
    color: #ffffff;
    cursor: pointer;
    transition: all 0.2s ease;
}

.btn-modal-delete:hover {
    background: #dc2626;
}

/* ==========================================================================
   Split ticket details & project chat system
   ========================================================================== */

.ticket-chat-modal-dialog {
    max-width: 1450px !important;
    width: 96vw !important;
    margin: 16px auto !important;
}

.ticket-chat-modal-content {
    border-radius: 16px !important;
    border: 1px solid #e2e8f0 !important;
    box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.28) !important;
    background: #ffffff !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
    height: 86vh !important;
    max-height: 870px !important;
    min-height: 600px !important;
}

/* CRM Top Bar (Matching Lead Details UI) */
.crm-modal-top-bar {
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    padding: 12px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-shrink: 0;
    z-index: 10;
}

.crm-top-bar-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.crm-modal-icon-box {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    background: #eff6ff;
    color: #2563eb;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    flex-shrink: 0;
    border: 1px solid #dbeafe;
}

.crm-title-group {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
}

.crm-title-row {
    display: flex;
    align-items: center;
    gap: 10px;
}

.crm-modal-title {
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    font-family: var(--font-heading);
    margin: 0;
    line-height: 1.2;
}

.crm-ref-badge-wrap {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    background: #f1f5f9;
    padding: 2px 7px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
}

.crm-ref-code {
    font-family: var(--font-mono, monospace);
    font-size: 11px;
    font-weight: 700;
    color: #475569;
    letter-spacing: 0.3px;
}

.btn-copy-ref {
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
    font-size: 11px;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.15s ease;
}

.btn-copy-ref:hover {
    color: #2563eb;
}

.crm-modal-sub {
    font-size: 11.5px;
    color: #64748b;
    font-weight: 500;
}

.crm-top-bar-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
}


.crm-status-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11.5px;
    font-weight: 700;
    text-transform: capitalize;
}

.crm-status-pill.status-open {
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #bfdbfe;
}

.crm-status-pill.status-in_progress {
    background: #fefce8;
    color: #a16207;
    border: 1px solid #fef08a;
}

.crm-status-pill.status-resolved {
    background: #ecfdf5;
    color: #047857;
    border: 1px solid #a7f3d0;
}

.crm-status-pill.status-closed {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
}

.crm-status-pill .status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
}

.crm-priority-pill {
    padding: 4px 12px;
    border-radius: 20px;
    font-size: 11.5px;
    font-weight: 700;
    letter-spacing: 0.2px;
}

.crm-priority-pill.priority-urgent,
.crm-priority-pill.priority-high {
    background: #f5f3ff;
    color: #6d28d9;
    border: 1px solid #ddd6fe;
}

.crm-priority-pill.priority-medium,
.crm-priority-pill.priority-normal {
    background: #eff6ff;
    color: #1d4ed8;
    border: 1px solid #bfdbfe;
}

.crm-priority-pill.priority-low {
    background: #f1f5f9;
    color: #475569;
    border: 1px solid #cbd5e1;
}

.crm-modal-close-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid transparent;
    background: transparent;
    color: #64748b;
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
}

.crm-modal-close-btn:hover {
    background: #f1f5f9;
    color: #0f172a;
    border-color: #e2e8f0;
}

/* CRM Subnav Navigation Tabs */
.crm-modal-subnav {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 0 24px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    flex-shrink: 0;
}

.crm-subnav-tab {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 9px 14px;
    font-size: 12.5px;
    font-weight: 600;
    color: #64748b;
    background: transparent;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    transition: all 0.15s ease;
}

.crm-subnav-tab:hover {
    color: #1e293b;
}

.crm-subnav-tab.active {
    color: #2563eb;
    border-bottom-color: #2563eb;
    font-weight: 700;
}

.crm-subnav-badge {
    background: #2563eb;
    color: #ffffff;
    font-size: 10px;
    font-weight: 700;
    padding: 1px 6px;
    border-radius: 10px;
}



/* Two-column Split Wrapper: Gray outer container, padding, gap between two distinct cards, NO middle line! */
.ticket-split-wrapper {
    display: flex;
    flex: 1 1;
    min-height: 0;
    overflow: hidden;
    background: #f1f5f9;
    padding: 16px 20px;
    gap: 16px;
}

/* Left Card / "Modal": Standalone rounded white card with border & shadow */
.ticket-details-pane {
    flex: 0 0 46%;
    max-width: 46%;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
    display: flex;
    flex-direction: column;
    min-height: 0;
    overflow: hidden;
}

.pane-card-title-bar {
    padding: 12px 18px;
    border-bottom: 1px solid #e2e8f0;
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
    display: flex;
    align-items: center;
    background: #ffffff;
    flex-shrink: 0;
}

.ticket-details-inner-scroll {
    flex: 1 1;
    overflow-y: auto;
    padding: 16px 18px;
    display: flex;
    flex-direction: column;
    gap: 14px;
    scrollbar-width: none;
    /* Hide scrollbar on Firefox */
    -ms-overflow-style: none;
    /* Hide scrollbar on IE/Edge */
}

.ticket-details-inner-scroll::-webkit-scrollbar {
    display: none;
    /* Hide scrollbar on Chrome/Safari/Brave */
}

.crm-field-card {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.crm-field-card.subject-card {
    padding-bottom: 8px;
    border-bottom: 1px solid #f1f5f9;
}

.crm-field-label {
    font-size: 10.5px;
    font-weight: 700;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.4px;
}

.crm-subject-heading {
    font-family: var(--font-heading);
    font-size: 15px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.35;
    margin: 0;
    word-break: break-word;
}

.crm-attributes-grid {
    display: flex;
    flex-direction: column;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
}

.crm-attr-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 14px;
    border-bottom: 1px solid #edf2f7;
    font-size: 12px;
}

.crm-attr-row:last-child {
    border-bottom: none;
}

.attr-label {
    color: #64748b;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 4px;
}

.attr-value {
    color: #0f172a;
    font-weight: 600;
    text-align: right;
}

.crm-mini-pill {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 10.5px;
    font-weight: 700;
    text-transform: capitalize;
}

.crm-mini-pill.priority-urgent,
.crm-mini-pill.priority-high {
    background: #fef2f2;
    color: #dc2626;
    border: 1px solid #fecaca;
}

.crm-mini-pill.priority-medium,
.crm-mini-pill.priority-normal {
    background: #eff6ff;
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.crm-mini-pill.priority-low {
    background: #f1f5f9;
    color: #64748b;
    border: 1px solid #e2e8f0;
}

.crm-desc-content {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    padding: 10px 12px;
}

.crm-desc-text {
    font-size: 12.5px;
    line-height: 1.5;
    color: #334155;
    margin: 0;
    white-space: pre-wrap;
    word-break: break-word;
}

.crm-desc-empty {
    font-size: 12px;
    color: #94a3b8;
    margin: 0;
    font-style: italic;
}

.crm-att-count {
    font-size: 11px;
    color: #64748b;
    font-weight: 600;
    background: #f1f5f9;
    padding: 1px 7px;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
}



/* Modal Bottom Footer */
.ticket-modal-bottom-footer {
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
    padding: 10px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.footer-left {
    display: flex;
    align-items: center;
    font-size: 11.5px;
    color: #64748b;
    font-weight: 500;
}

.footer-timestamp {
    color: #64748b;
    font-size: 11.5px;
}

.btn-footer-close {
    padding: 5px 16px;
    font-size: 12px;
    font-weight: 600;
    color: #475569;
    background: #f8fafc;
    border: 1px solid #cbd5e1;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.btn-footer-close:hover {
    background: #f1f5f9;
    color: #0f172a;
    border-color: #94a3b8;
}

/* Screenshots Grid */
.ticket-screenshots-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
    gap: 10px;
}

.ticket-screen-thumb-card {
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
    background: #f8fafc;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.ticket-screen-thumb-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

.thumb-img-wrapper {
    position: relative;
    height: 70px;
    width: 100%;
    background: #0f172a;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.thumb-actual-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease;
}

.ticket-screen-thumb-card:hover .thumb-actual-img {
    transform: scale(1.05);
}

.thumb-hover-overlay {
    position: absolute;
    inset: 0;
    background: rgba(15, 23, 42, 0.55);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 3px;
    color: #ffffff;
    font-size: 11px;
    font-weight: 600;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.thumb-hover-overlay i {
    font-size: 16px;
}

.ticket-screen-thumb-card:hover .thumb-hover-overlay {
    opacity: 1;
}

.thumb-caption {
    padding: 6px 8px;
    background: #ffffff;
    border-top: 1px solid #f1f5f9;
}

.thumb-name {
    display: block;
    font-size: 10.5px;
    font-weight: 600;
    color: #475569;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.attachments-empty-card {
    padding: 16px;
    text-align: center;
    color: #94a3b8;
    font-size: 12px;
    background: #f8fafc;
    border: 1px dashed #cbd5e1;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}

/* Assigned PM Card */
.ticket-pm-card {
    background: linear-gradient(135deg, #f8fafc, #eff6ff);
    border: 1px solid #dbeafe;
    border-radius: 12px;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.pm-card-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.pm-avatar-wrap {
    position: relative;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f46e5, #4338ca);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.25);
    flex-shrink: 0;
}

.pm-status-indicator {
    position: absolute;
    bottom: -1px;
    right: -1px;
    width: 10px;
    height: 10px;
    background: #10b981;
    border: 2px solid #ffffff;
    border-radius: 50%;
}

.pm-info-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.pm-name-row {
    display: flex;
    align-items: center;
    gap: 6px;
}

.pm-name {
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
}

.pm-role-tag {
    font-size: 10px;
    font-weight: 700;
    color: #2563eb;
    background: #dbeafe;
    padding: 1px 6px;
    border-radius: 4px;
}

.pm-response-note {
    font-size: 11px;
    color: #64748b;
    line-height: 1.4;
}

.ticket-pm-card {
    background: linear-gradient(135deg, #f8fafc, #eff6ff);
    border: 1px solid #dbeafe;
    border-radius: 12px;
    padding: 12px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    flex-wrap: wrap;
}

/* Right Card / "Modal": Standalone rounded white card with border & shadow */
.ticket-chat-pane {
    flex: 1 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);
    min-height: 0;
    overflow: hidden;
}

/* Chat Header */
.ticket-chat-header {
    padding: 12px 20px;
    background: #ffffff;
    border-bottom: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
}

.chat-header-user {
    display: flex;
    align-items: center;
    gap: 12px;
}

.chat-pm-avatar {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f46e5, #6366f1);
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 14px;
    box-shadow: 0 4px 10px rgba(79, 70, 229, 0.25);
    flex-shrink: 0;
}

.chat-online-dot {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 11px;
    height: 11px;
    background: #10b981;
    border: 2px solid #ffffff;
    border-radius: 50%;
}

.chat-pm-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.chat-pm-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
}

.chat-pm-title {
    font-family: var(--font-heading);
    font-size: 14px;
    font-weight: 800;
    color: #0f172a;
}

.chat-badge-admin {
    font-size: 10px;
    font-weight: 700;
    color: #4f46e5;
    background: #eef2ff;
    padding: 2px 7px;
    border-radius: 999px;
    border: 1px solid #e0e7ff;
}

.chat-pm-status {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11.5px;
    color: #64748b;
}

.pulse-dot-sm {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #10b981;
    display: inline-block;
    position: relative;
}

.pulse-dot-sm.emerald {
    background: #10b981;
    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
}

.chat-workspace-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
}

/* Chat Messages Wrap */
.ticket-chat-messages-wrap {
    flex: 1 1;
    min-height: 0;
    overflow-y: auto;
    padding: 16px 20px;
    background: #fafbfc;
    display: flex;
    flex-direction: column;
    gap: 14px;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
}

.ticket-chat-messages-wrap::-webkit-scrollbar {
    width: 5px;
}

.ticket-chat-messages-wrap::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
}

.chat-intro-banner {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 10px 14px;
    background: #eef2ff;
    border: 1px solid #e0e7ff;
    border-radius: 10px;
}

.intro-icon {
    font-size: 16px;
    color: #4f46e5;
    margin-top: 1px;
}

.intro-text {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 11.5px;
    color: #3730a3;
    line-height: 1.4;
}

.intro-text strong {
    font-weight: 700;
    color: #312e81;
}

.chat-date-separator {
    text-align: center;
    position: relative;
    margin: 6px 0;
}

.chat-date-separator::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 50%;
    height: 1px;
    background: #e2e8f0;
}

.chat-date-separator span {
    position: relative;
    background: #ffffff;
    padding: 2px 12px;
    border-radius: 999px;
    border: 1px solid #e2e8f0;
    font-size: 10.5px;
    font-weight: 600;
    color: #94a3b8;
}

.chat-message-list {
    display: flex;
    flex-direction: column;
    gap: 14px;
}

.chat-message-row {
    display: flex;
    gap: 10px;
    max-width: 84%;
    align-items: flex-end;
}

.chat-message-row.from-pm {
    align-self: flex-start;
}

.chat-message-row.from-client {
    align-self: flex-end;
    flex-direction: row;
}

.msg-sender-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    flex-shrink: 0;
    margin-bottom: 4px;
}

.msg-sender-avatar.pm {
    background: linear-gradient(135deg, #eef2ff, #e0e7ff);
    color: #4f46e5;
    border: 1px solid #c7d2fe;
}

.msg-sender-avatar.client {
    background: #0f172a;
    color: #ffffff;
}

.meta-avatar-xs {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: #eef2ff;
    color: #4f46e5;
    font-size: 10px;
    font-weight: 700;
    border: 1px solid #c7d2fe;
}

.meta-avatar-xs.rt-badge {
    background: linear-gradient(135deg, #4f46e5, #6366f1);
    color: #ffffff;
    border: none;
    box-shadow: 0 1px 3px rgba(79, 70, 229, 0.25);
}

.chat-pm-avatar.rt-avatar {
    background: linear-gradient(135deg, #4f46e5, #6366f1);
    color: #ffffff;
}

.chat-empty-thread {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 56px 20px;
    margin: auto 0;
}

.chat-empty-icon-wrap {
    width: 54px;
    height: 54px;
    border-radius: 50%;
    background: #f1f5f9;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin-bottom: 14px;
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.05);
}

.chat-empty-title {
    font-family: var(--font-heading);
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 6px;
}

.chat-empty-desc {
    font-size: 12.5px;
    color: #64748b;
    max-width: 320px;
    line-height: 1.5;
    margin: 0;
}

.msg-bubble-container {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
}

.chat-message-row.from-client .msg-bubble-container {
    align-items: flex-end;
}

.msg-meta-row {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10.5px;
    color: #94a3b8;
    padding: 0 4px;
}

.msg-sender-label {
    font-weight: 700;
    color: #475569;
}

.msg-bubble {
    padding: 10px 14px;
    border-radius: 14px;
    font-size: 12.5px;
    line-height: 1.5;
    word-break: break-word;
    position: relative;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.bubble-pm {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    color: #1e293b;
    border-bottom-left-radius: 4px;
}

.bubble-client {
    background: linear-gradient(135deg, #4f46e5, #4338ca);
    color: #ffffff;
    border-bottom-right-radius: 4px;
    box-shadow: 0 4px 14px rgba(79, 70, 229, 0.25);
}

.msg-bubble-text {
    white-space: pre-wrap;
}

.msg-status-indicator {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 10.5px;
    color: #94a3b8;
    padding-right: 4px;
}

/* Chat Attachment Card */
.msg-attachment-card {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(255, 255, 255, 0.15);
    border: 1px solid rgba(255, 255, 255, 0.25);
    padding: 6px 10px;
    border-radius: 8px;
}

.bubble-pm .msg-attachment-card {
    background: #f8fafc;
    border-color: #e2e8f0;
}

.attachment-icon {
    font-size: 16px;
}

.attachment-details {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.attachment-name {
    font-size: 11px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 160px;
}

.attachment-size {
    font-size: 10px;
    opacity: 0.85;
}

.btn-view-att {
    background: transparent;
    border: none;
    color: inherit;
    cursor: pointer;
    font-size: 13px;
    padding: 2px 6px;
    margin-left: auto;
}

.msg-screenshots-preview {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
    font-size: 11px;
    opacity: 0.9;
}

/* Typing Indicator */
.typing-bubble {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 10px 14px;
    min-width: 54px;
}

.typing-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #6366f1;
    animation: typingBounce 1.4s infinite ease-in-out both;
}

.typing-dot:nth-child(1) {
    animation-delay: -0.32s;
}

.typing-dot:nth-child(2) {
    animation-delay: -0.16s;
}

@keyframes typingBounce {

    0%,
    80%,
    100% {
        transform: scale(0);
        opacity: 0.4;
    }

    40% {
        transform: scale(1);
        opacity: 1;
    }
}

/* Quick Suggestions Chips */
.chat-quick-suggestions {
    padding: 6px 20px;
    background: #ffffff;
    border-top: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
}

.suggestions-label {
    font-size: 10.5px;
    font-weight: 700;
    color: #94a3b8;
    white-space: nowrap;
}

.suggestions-scroll {
    display: flex;
    gap: 6px;
    overflow-x: auto;
    padding-bottom: 2px;
}

.suggestions-scroll::-webkit-scrollbar {
    display: none;
}

.btn-suggestion-chip {
    padding: 3px 10px;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.15s ease;
}

.btn-suggestion-chip:hover {
    background: #eef2ff;
    border-color: #c7d2fe;
    color: #4f46e5;
    transform: translateY(-1px);
}

/* Chat Input Area */
.ticket-chat-input-area {
    padding: 12px 20px 14px 20px;
    background: #ffffff;
    border-top: 1px solid #e2e8f0;
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex-shrink: 0;
}

.chat-attachment-pending-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 10px;
    background: #f1f5f9;
    border: 1px solid #e2e8f0;
    border-radius: 6px;
}

.pending-att-left {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11.5px;
    color: #334155;
    min-width: 0;
}

.pending-att-name {
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 260px;
}

.pending-att-size {
    color: #64748b;
    font-size: 10.5px;
}

.btn-remove-pending-att {
    background: transparent;
    border: none;
    color: #ef4444;
    cursor: pointer;
    font-size: 13px;
    padding: 0 4px;
}

.chat-input-form {
    display: flex;
    align-items: center;
    gap: 8px;
    position: relative;
}

.btn-chat-action-tool {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #64748b;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
}

.btn-chat-action-tool:hover {
    background: #eef2ff;
    color: #4f46e5;
    border-color: #c7d2fe;
}

.chat-input-field {
    flex: 1 1;
    height: 38px;
    padding: 8px 14px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 12.5px;
    color: #1e293b;
    background: #f8fafc;
    outline: none;
    transition: all 0.2s ease;
}

.chat-input-field:focus {
    background: #ffffff;
    border-color: #4f46e5;
    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
}

.btn-chat-send-submit {
    height: 38px;
    padding: 0 16px;
    background: linear-gradient(135deg, #4f46e5, #4338ca);
    color: #ffffff;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 3px 10px rgba(79, 70, 229, 0.3);
    transition: all 0.15s ease;
    flex-shrink: 0;
}

.btn-chat-send-submit:hover:not(:disabled) {
    background: linear-gradient(135deg, #4338ca, #3730a3);
    transform: translateY(-1px);
    box-shadow: 0 5px 14px rgba(79, 70, 229, 0.4);
}

.btn-chat-send-submit:disabled {
    background: #cbd5e1;
    cursor: not-allowed;
    box-shadow: none;
}

.chat-input-helper-note {
    font-size: 10.5px;
    color: #94a3b8;
    display: flex;
    align-items: center;
}

/* ==========================================================================
   Screenshot / Image Preview Lightbox (Premium, High Contrast, Frosted Blur)
   ========================================================================== */

.support-img-preview-backdrop {
    z-index: 1065 !important;
    background-color: rgba(10, 15, 30, 0.8) !important;
    backdrop-filter: blur(8px) !important;
    -webkit-backdrop-filter: blur(8px) !important;
}

.support-img-preview-dialog {
    z-index: 1070 !important;
    max-width: 1100px !important;
    width: 94vw !important;
    margin: 24px auto !important;
}

.support-img-preview-content {
    background: #0f172a !important;
    border-radius: 16px !important;
    border: 1px solid rgba(255, 255, 255, 0.12) !important;
    box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.65) !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
}

.support-img-preview-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 22px;
    background: #1e293b;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    gap: 16px;
    flex-shrink: 0;
}

.preview-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
}

.preview-icon-box {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    background: rgba(99, 102, 241, 0.15);
    color: #818cf8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    border: 1px solid rgba(99, 102, 241, 0.3);
    flex-shrink: 0;
}

.preview-title-group {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.preview-modal-title {
    font-family: var(--font-heading);
    font-size: 15px;
    font-weight: 700;
    color: #f8fafc;
    margin: 0;
    line-height: 1.2;
}

.preview-modal-subtitle {
    font-size: 11.5px;
    color: #94a3b8;
    font-weight: 500;
}

.preview-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.btn-preview-tool {
    display: inline-flex;
    align-items: center;
    padding: 6px 14px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 7px;
    color: #f1f5f9;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.15s ease;
}

.btn-preview-tool:hover {
    background: rgba(255, 255, 255, 0.16);
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.3);
    text-decoration: none;
    transform: translateY(-1px);
}

.btn-preview-close {
    width: 32px;
    height: 32px;
    border-radius: 7px;
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #cbd5e1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    transition: all 0.15s ease;
}

.btn-preview-close:hover {
    background: #ef4444;
    border-color: #ef4444;
    color: #ffffff;
    transform: translateY(-1px);
}

.support-img-preview-body {
    padding: 24px;
    background: #090d16;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 360px;
    max-height: 78vh;
    overflow: auto;
}

.preview-img-container {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 100%;
}

.preview-display-img {
    max-width: 100%;
    max-height: 72vh;
    object-fit: contain;
    display: block;
    border-radius: 8px;
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.1);
}

@media (max-width: 992px) {
    .support-kpi-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 10px;
    }

    .support-table th,
    .support-table td {
        padding: 10px 12px;
    }
}

@media (max-width: 768px) {
    .support-tickets-card .pro-card-header {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        padding: 12px 14px;
    }

    .card-header-actions {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
    }

    .support-search-wrap {
        width: 100% !important;
    }

    .custom-popover-dropdown {
        flex: 1 1;
        min-width: 130px;
    }

    .custom-dropdown-btn {
        width: 100%;
        justify-content: space-between;
    }

    .table-responsive {
        -webkit-overflow-scrolling: touch;
        overflow-x: auto;
        width: 100%;
    }

    .support-table {
        min-width: 780px;
    }
}

@media (max-width: 576px) {
    .support-kpi-grid {
        grid-template-columns: 1fr;
        gap: 8px;
    }

    .support-kpi-card {
        padding: 12px 14px;
        gap: 12px;
    }

    .support-kpi-val {
        font-size: 18px;
    }

    .custom-popover-dropdown {
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: calc(50% - 4px);
        min-width: 110px;
    }

    .date-range-popover {
        position: fixed !important;
        left: 14px !important;
        right: 14px !important;
        top: 50% !important;
        transform: translateY(-50%) !important;
        min-width: auto !important;
        width: auto !important;
        max-width: calc(100vw - 28px) !important;
        box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.35) !important;
        z-index: 1050 !important;
    }

    .screenshot-preview-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 6px;
    }

    .custom-support-modal .modal-body {
        padding: 16px 14px;
    }

    .custom-support-modal .modal-header {
        padding: 12px 16px;
    }

    .custom-support-modal .modal-footer {
        padding: 10px 14px;
        flex-direction: column;
        gap: 8px;
    }

    .custom-support-modal .btn-modal-cancel,
    .custom-support-modal .btn-modal-submit,
    .custom-support-modal .btn-modal-delete {
        width: 100%;
        justify-content: center;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/Support.css"],"names":[],"mappings":"AAAA;;+EAE+E;;AAE/E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,0BAA0B;AAC1B;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kEAAkE;IAClE,cAAc;IACd,YAAY;IACZ,+BAA+B;IAC/B,gCAAgC;IAChC,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,qDAAqD;IACrD,8CAA8C;IAC9C,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,8BAA8B;IAC9B,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,+CAA+C;AACnD;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,kCAAkC;IAClC,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,QAAQ;IACR,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,2FAA2F;IAC3F,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gEAAgE;AACpE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;AAC9B;;AAEA;;IAEI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,qBAAqB;IACrB,kBAAkB;IAClB,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,oBAAoB;IACpB,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,SAAS;IACT,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;IACvB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,6CAA6C;IAC7C,8CAA8C;IAC9C,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI;QACI,mBAAmB;QACnB,6CAA6C;IACjD;IACA;QACI,qBAAqB;QACrB,6CAA6C;IACjD;AACJ;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,sBAAsB;AACtB;IACI,uCAAuC;IACvC,mBAAmB;IACnB,mDAAmD;IACnD,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,uCAAuC;IACvC,+BAA+B;IAC/B,mBAAmB;IACnB,0BAA0B;IAC1B,yBAAyB;IACzB,aAAa;AACjB;;AAEA;;IAEI,kCAAkC;IAClC,+CAA+C;AACnD;;AAEA,eAAe;AACf;IACI,0BAA0B;IAC1B,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kDAAkD;IAClD,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iBAAiB;IACjB,gCAAgC;IAChC,sCAAsC;IACtC,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;+EAE+E;;AAE/E;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,+DAA+D;IAC/D,8BAA8B;IAC9B,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;IACvB,4BAA4B;IAC5B,4BAA4B;AAChC;;AAEA,2CAA2C;AAC3C;IACI,mBAAmB;IACnB,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,eAAe;IACf,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;AAClB;;;AAGA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,mBAAmB;IACnB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;;;AAIA,6GAA6G;AAC7G;IACI,aAAa;IACb,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA,4EAA4E;AAC5E;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;IAC5C,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;IACrB,8BAA8B;IAC9B,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;AAC7B;;;;AAIA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,kDAAkD;AACtD;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;AACnC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,kCAAkC;IAClC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA,qBAAqB;AACrB;IACI,qDAAqD;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;AACnB;;AAEA,6EAA6E;AAC7E;IACI,SAAO;IACP,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4CAA4C;IAC5C,aAAa;IACb,gBAAgB;AACpB;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qDAAqD;IACrD,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,8CAA8C;IAC9C,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;IACrB,oCAAoC;AACxC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,qDAAqD;IACrD,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,+BAA+B;IAC/B,8CAA8C;AAClD;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,qCAAqC;IACrC,2CAA2C;IAC3C,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,8CAA8C;IAC9C,eAAe;IACf,YAAY;AAChB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sDAAsD;AAC1D;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI;;;QAGI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA,4BAA4B;AAC5B;IACI,iBAAiB;IACjB,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,4BAA4B;IAC5B,mBAAmB;IACnB,6BAA6B;IAC7B,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,qDAAqD;IACrD,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,6CAA6C;IAC7C,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,qDAAqD;IACrD,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;;+EAE+E;;AAE/E;IACI,wBAAwB;IACxB,kDAAkD;IAClD,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,sDAAsD;IACtD,4DAA4D;IAC5D,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,kDAAkD;IAClD,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,sCAAsC;IACtC,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,0CAA0C;IAC1C,0CAA0C;AAC9C;;AAEA;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;;IAEA;;QAEI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,SAAO;QACP,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,iCAAiC;QACjC,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,kBAAkB;QAClB,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAyB;QAAzB,cAAyB;QAAzB,2BAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;QAC1B,qBAAqB;QACrB,sBAAsB;QACtB,mBAAmB;QACnB,sCAAsC;QACtC,0BAA0B;QAC1B,sBAAsB;QACtB,wCAAwC;QACxC,+DAA+D;QAC/D,wBAAwB;IAC5B;;IAEA;QACI,qCAAqC;QACrC,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;;;QAGI,WAAW;QACX,uBAAuB;IAC3B;AACJ","sourcesContent":["/* ==========================================================================\n   SUPPORT & HELP CENTER STYLES\n   ========================================================================== */\n\n.support-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 12px;\n    margin-bottom: 16px;\n}\n\n.support-kpi-card {\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-md);\n    padding: 14px 16px;\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    box-shadow: var(--shadow-subtle);\n    transition: all 0.2s ease;\n}\n\n.support-kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-card);\n    border-color: #cbd5e1;\n}\n\n.support-kpi-icon {\n    width: 42px;\n    height: 42px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    flex-shrink: 0;\n}\n\n.icon-purple-soft {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n.icon-amber-soft {\n    background: #fffbeb;\n    color: #d97706;\n}\n\n.icon-emerald-soft {\n    background: #ecfdf5;\n    color: #059669;\n}\n\n.icon-sky-soft {\n    background: #f0f9ff;\n    color: #0284c7;\n}\n\n.support-kpi-content {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.support-kpi-label {\n    font-size: 11.5px;\n    font-weight: 600;\n    color: var(--text-muted);\n    margin-bottom: 2px;\n}\n\n.support-kpi-val {\n    font-family: var(--font-heading);\n    font-size: 20px;\n    font-weight: 800;\n    color: var(--text-heading);\n    line-height: 1.1;\n}\n\n.support-kpi-sub {\n    font-size: 10.5px;\n    color: var(--text-light);\n    margin-top: 3px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* Primary Action Button */\n.btn-create-ticket-primary {\n    display: inline-flex;\n    align-items: center;\n    gap: 7px;\n    padding: 8px 16px;\n    background: linear-gradient(135deg, var(--brand-primary), #4338ca);\n    color: #ffffff;\n    border: none;\n    border-radius: var(--radius-md);\n    font-family: var(--font-heading);\n    font-size: 12.5px;\n    font-weight: 700;\n    cursor: pointer;\n    box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    white-space: nowrap;\n}\n\n.btn-create-ticket-primary:hover {\n    background: linear-gradient(135deg, #4f46e5, #3730a3);\n    box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);\n    transform: translateY(-1px);\n    color: #ffffff;\n}\n\n.btn-create-ticket-primary i {\n    font-size: 14px;\n}\n\n/* Support Tickets Table Card */\n.support-tickets-card {\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-md);\n    box-shadow: var(--shadow-card);\n    overflow: visible;\n    display: flex;\n    flex-direction: column;\n}\n\n.support-tickets-card .pro-card-header {\n    padding: 14px 18px;\n    background: #ffffff;\n    border-bottom: 1px solid var(--surface-border-subtle);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    flex-wrap: wrap;\n    position: relative;\n    z-index: 20;\n}\n\n.card-header-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.support-search-wrap {\n    position: relative;\n    width: 175px;\n}\n\n.support-search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #94a3b8;\n    font-size: 12px;\n    pointer-events: none;\n}\n\n.support-search-input {\n    width: 100%;\n    height: 32px;\n    padding: 4px 10px 4px 30px;\n    font-size: 12px;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    background: #f8fafc;\n    color: var(--text-heading);\n    outline: none;\n    transition: all 0.2s ease;\n}\n\n.support-search-input:focus {\n    background: #ffffff;\n    border-color: var(--brand-primary);\n    box-shadow: 0 0 0 2px var(--brand-primary-glow);\n}\n\n/* Custom Popover Dropdowns */\n.custom-popover-dropdown {\n    position: relative;\n}\n\n.custom-dropdown-btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n    height: 32px;\n    padding: 0 10px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n}\n\n.custom-dropdown-btn:hover,\n.custom-dropdown-btn.active {\n    background: #ffffff;\n    border-color: var(--brand-primary);\n    box-shadow: 0 0 0 2px var(--brand-primary-glow);\n    color: var(--brand-primary);\n}\n\n.custom-dropdown-btn i.chevron {\n    font-size: 10px;\n    color: #94a3b8;\n    transition: transform 0.2s ease;\n}\n\n.custom-dropdown-btn.active i.chevron {\n    transform: rotate(180deg);\n    color: var(--brand-primary);\n}\n\n.custom-dropdown-popover {\n    position: absolute;\n    top: calc(100% + 5px);\n    right: 0;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.12), 0 8px 10px -6px rgba(15, 23, 42, 0.05);\n    padding: 5px;\n    min-width: 160px;\n    z-index: 120;\n    animation: dropdownFadeSlide 0.16s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.custom-popover-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 7px 10px;\n    border-radius: 5px;\n    font-size: 12px;\n    font-weight: 500;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.12s ease;\n}\n\n.custom-popover-item:hover {\n    background: #f1f5f9;\n    color: var(--brand-primary);\n}\n\n.custom-popover-item.selected {\n    background: #eef2ff;\n    color: #4f46e5;\n    font-weight: 600;\n}\n\n.item-left-content {\n    display: flex;\n    align-items: center;\n    gap: 7px;\n}\n\n.item-dot {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n}\n\n/* Date Range Popover Specifics */\n.date-range-popover {\n    min-width: 290px;\n    padding: 12px 14px;\n}\n\n.date-preset-pills {\n    display: flex;\n    gap: 6px;\n    flex-wrap: wrap;\n    margin-bottom: 10px;\n    padding-bottom: 8px;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.btn-preset-pill {\n    padding: 3px 8px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    font-size: 10.5px;\n    font-weight: 600;\n    color: #475569;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.btn-preset-pill:hover,\n.btn-preset-pill.active {\n    background: #4f46e5;\n    border-color: #4f46e5;\n    color: #ffffff;\n}\n\n.date-inputs-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 10px;\n}\n\n.date-input-group {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n}\n\n.date-input-group label {\n    font-size: 10.5px;\n    font-weight: 700;\n    color: #64748b;\n    margin: 0;\n}\n\n.date-input-field {\n    width: 100%;\n    height: 30px;\n    padding: 2px 6px;\n    font-size: 11.5px;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    outline: none;\n    color: #1e293b;\n    background: #f8fafc;\n}\n\n.date-input-field:focus {\n    background: #ffffff;\n    border-color: var(--brand-primary);\n}\n\n.date-popover-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 6px;\n}\n\n.btn-date-clear {\n    padding: 4px 10px;\n    font-size: 11px;\n    font-weight: 600;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 5px;\n    color: #64748b;\n    cursor: pointer;\n}\n\n.btn-date-apply {\n    padding: 4px 12px;\n    font-size: 11px;\n    font-weight: 700;\n    background: var(--brand-primary);\n    border: 1px solid var(--brand-primary);\n    border-radius: 5px;\n    color: #ffffff;\n    cursor: pointer;\n}\n\n.btn-clear-filters {\n    height: 32px;\n    padding: 0 10px;\n    font-size: 11.5px;\n    font-weight: 600;\n    border: 1px dashed #cbd5e1;\n    border-radius: 6px;\n    background: #ffffff;\n    color: #64748b;\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.btn-clear-filters:hover {\n    background: #fef2f2;\n    color: #ef4444;\n    border-color: #fecaca;\n}\n\n/* Table Specific Rules */\n.support-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12px;\n    height: auto !important;\n    flex: none !important;\n}\n\n.support-table thead th {\n    background: #f8fafc;\n    color: #64748b;\n    font-size: 10.5px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    padding: 10px 14px;\n    border-bottom: 1px solid #e2e8f0;\n    white-space: nowrap;\n}\n\n.support-table tbody tr {\n    transition: background-color 0.15s ease;\n    border-bottom: 1px solid #f1f5f9;\n    cursor: pointer;\n}\n\n.support-table tbody tr:last-child {\n    border-bottom: none;\n}\n\n.support-table tbody tr:hover {\n    background-color: #f1f5f9;\n}\n\n.support-table td {\n    padding: 12px 14px;\n    vertical-align: middle;\n}\n\n.cell-index-badge {\n    font-size: 11px;\n    font-weight: 700;\n    color: #94a3b8;\n    font-family: var(--font-mono);\n}\n\n.ticket-title-link {\n    color: #1e293b;\n    font-weight: 700;\n    font-size: 13px;\n    text-decoration: none;\n    cursor: pointer;\n    display: inline-block;\n    margin-bottom: 3px;\n    transition: color 0.15s ease;\n}\n\n.ticket-title-link:hover {\n    color: var(--brand-primary);\n}\n\n.ticket-desc-snippet {\n    font-size: 11.5px;\n    color: #64748b;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 380px;\n    line-height: 1.3;\n}\n\n.project-tag-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 3px 9px;\n    border-radius: var(--radius-full);\n    font-size: 11px;\n    font-weight: 600;\n    background: #eff6ff;\n    color: #2563eb;\n    border: 1px solid #dbeafe;\n    white-space: nowrap;\n}\n\n.category-tag-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 9px;\n    border-radius: var(--radius-full);\n    font-size: 11px;\n    font-weight: 600;\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n    text-transform: capitalize;\n    white-space: nowrap;\n}\n\n.priority-badge-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 4px;\n    padding: 3px 9px;\n    border-radius: var(--radius-full);\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: capitalize;\n    white-space: nowrap;\n}\n\n.priority-urgent,\n.priority-high {\n    background: #fef2f2;\n    color: #dc2626;\n    border: 1px solid #fecaca;\n}\n\n.priority-medium {\n    background: #fffbeb;\n    color: #d97706;\n    border: 1px solid #fde68a;\n}\n\n.priority-low {\n    background: #f0fdf4;\n    color: #16a34a;\n    border: 1px solid #bbf7d0;\n}\n\n.ticket-status-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 3px 10px;\n    border-radius: var(--radius-full);\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: capitalize;\n    white-space: nowrap;\n}\n\n.status-resolved,\n.status-closed {\n    background: #ecfdf5;\n    color: #059669;\n    border: 1px solid #a7f3d0;\n}\n\n.status-in_progress {\n    background: #fffbeb;\n    color: #d97706;\n    border: 1px solid #fde68a;\n}\n\n.status-open {\n    background: #eef2ff;\n    color: #4f46e5;\n    border: 1px solid #c7d2fe;\n}\n\n.status-dot-sm {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n}\n\n.status-resolved .status-dot-sm,\n.status-closed .status-dot-sm {\n    background-color: #059669;\n}\n\n.status-in_progress .status-dot-sm {\n    background-color: #d97706;\n}\n\n.status-open .status-dot-sm {\n    background-color: #4f46e5;\n}\n\n.ticket-screenshots-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 3px 8px;\n    border-radius: 6px;\n    font-size: 11px;\n    font-weight: 600;\n    background: #f8fafc;\n    border: 1px solid #cbd5e1;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    white-space: nowrap;\n}\n\n.ticket-screenshots-badge:hover {\n    background: #e2e8f0;\n    color: #0f172a;\n    border-color: #94a3b8;\n}\n\n/* Action Buttons */\n.action-btn-group {\n    display: inline-flex;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 6px;\n    margin: 0;\n    padding: 0;\n}\n\n.action-btn-group button {\n    margin: 0 !important;\n}\n\n.btn-action-icon {\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    border-radius: 4px;\n    border: none;\n    background: transparent;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 15px;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    line-height: 1;\n}\n\n.btn-action-icon:hover {\n    transform: translateY(-1px);\n}\n\n.btn-action-icon.btn-edit:hover {\n    background: #fffbeb;\n    color: #d97706;\n}\n\n.btn-action-icon.btn-delete:hover {\n    background: #fef2f2;\n    color: #ef4444;\n}\n\n.btn-action-view-chat {\n    width: 24px;\n    height: 24px;\n    padding: 0;\n    border: none;\n    background: transparent;\n    color: #2563eb;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    cursor: pointer;\n    position: relative;\n    border-radius: 4px;\n    transition: all 0.15s ease;\n    line-height: 1;\n}\n\n.btn-action-view-chat:hover {\n    background: #eff6ff;\n    color: #1d4ed8;\n    transform: translateY(-1px);\n    border: none;\n}\n\n.btn-action-view-chat.has-unread {\n    border: none;\n    background: transparent;\n    color: #2563eb;\n}\n\n.btn-action-view-chat.has-unread:hover {\n    background: #eff6ff;\n    color: #1d4ed8;\n    border: none;\n}\n\n.client-action-unread-badge {\n    position: absolute;\n    top: -5px;\n    right: -5px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 15px;\n    height: 15px;\n    padding: 0 2px;\n    border-radius: 999px;\n    background: #ef4444;\n    color: #ffffff;\n    font-size: 0.62rem;\n    font-weight: 700;\n    line-height: 1;\n    border: 2px solid #ffffff;\n    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.45);\n    animation: unreadPulse 2s infinite ease-in-out;\n    pointer-events: none;\n    z-index: 2;\n}\n\n@keyframes unreadPulse {\n    0%, 100% {\n        transform: scale(1);\n        box-shadow: 0 2px 4px rgba(239, 68, 68, 0.45);\n    }\n    50% {\n        transform: scale(1.1);\n        box-shadow: 0 3px 8px rgba(239, 68, 68, 0.65);\n    }\n}\n\n.client-row-has-unread {\n    background-color: rgba(254, 242, 242, 0.45) !important;\n}\n\n.client-row-has-unread:hover {\n    background-color: rgba(254, 226, 226, 0.65) !important;\n}\n\n.client-unread-dot {\n    display: inline-block;\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #ef4444;\n    margin-right: 6px;\n    box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);\n}\n\n/* Empty State */\n.support-empty-state {\n    padding: 48px 20px;\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.support-empty-icon-wrap {\n    width: 54px;\n    height: 54px;\n    border-radius: 50%;\n    background: #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    color: var(--brand-primary);\n    margin-bottom: 12px;\n}\n\n.support-empty-title {\n    font-family: var(--font-heading);\n    font-size: 15px;\n    font-weight: 700;\n    color: var(--text-heading);\n    margin-bottom: 4px;\n}\n\n.support-empty-desc {\n    font-size: 12px;\n    color: var(--text-muted);\n    max-width: 360px;\n    margin-bottom: 16px;\n}\n\n/* Modal Form Styles */\n.custom-support-modal .modal-content {\n    border: 1px solid var(--surface-border);\n    border-radius: 14px;\n    box-shadow: 0 20px 35px -10px rgba(15, 23, 42, 0.2);\n    overflow: hidden;\n}\n\n.custom-support-modal .modal-header {\n    background: #fafbfc;\n    border-bottom: 1px solid var(--surface-border-subtle);\n    padding: 14px 20px;\n}\n\n.custom-support-modal .modal-title {\n    font-family: var(--font-heading);\n    font-size: 15px;\n    font-weight: 800;\n    color: var(--text-heading);\n}\n\n.custom-support-modal .modal-body {\n    padding: 20px;\n}\n\n.modal-form-label {\n    font-size: 11.5px;\n    font-weight: 700;\n    color: var(--text-heading);\n    margin-bottom: 5px;\n    display: block;\n}\n\n.modal-form-control,\n.modal-form-select {\n    width: 100%;\n    padding: 8px 12px;\n    font-size: 12.5px;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-sm);\n    background: #ffffff;\n    color: var(--text-heading);\n    transition: all 0.2s ease;\n    outline: none;\n}\n\n.modal-form-control:focus,\n.modal-form-select:focus {\n    border-color: var(--brand-primary);\n    box-shadow: 0 0 0 3px var(--brand-primary-glow);\n}\n\n/* Upload Box */\n.screenshot-upload-dropzone {\n    border: 2px dashed #cbd5e1;\n    border-radius: var(--radius-md);\n    padding: 16px 14px;\n    text-align: center;\n    background: #f8fafc;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    position: relative;\n}\n\n.screenshot-upload-dropzone:hover {\n    border-color: var(--brand-primary);\n    background: #f1f5f9;\n}\n\n.upload-icon-circle {\n    width: 38px;\n    height: 38px;\n    border-radius: 50%;\n    background: #e0e7ff;\n    color: var(--brand-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    margin: 0 auto 8px auto;\n}\n\n.upload-hint-main {\n    font-size: 12px;\n    font-weight: 700;\n    color: var(--text-heading);\n}\n\n.upload-hint-sub {\n    font-size: 10.5px;\n    color: var(--text-muted);\n}\n\n/* Screenshot Preview Strip */\n.screenshot-preview-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n    gap: 8px;\n    margin-top: 10px;\n}\n\n.screenshot-thumb-wrap {\n    position: relative;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    overflow: hidden;\n    height: 75px;\n    background: #f8fafc;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.screenshot-thumb-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.btn-remove-thumb {\n    position: absolute;\n    top: 3px;\n    right: 3px;\n    width: 20px;\n    height: 20px;\n    border-radius: 50%;\n    background: rgba(239, 68, 68, 0.9);\n    color: white;\n    border: none;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n    cursor: pointer;\n    transition: transform 0.15s ease;\n}\n\n.btn-remove-thumb:hover {\n    transform: scale(1.15);\n}\n\n.custom-support-modal .modal-footer {\n    background: #fafbfc;\n    border-top: 1px solid var(--surface-border-subtle);\n    padding: 12px 20px;\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n}\n\n.btn-modal-cancel {\n    padding: 7px 14px;\n    background: #ffffff;\n    border: 1px solid var(--surface-border);\n    border-radius: var(--radius-sm);\n    font-size: 12px;\n    font-weight: 600;\n    color: var(--text-body);\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-modal-cancel:hover {\n    background: var(--surface-subtle);\n}\n\n.btn-modal-submit {\n    padding: 7px 16px;\n    background: var(--brand-primary);\n    border: 1px solid var(--brand-primary);\n    border-radius: var(--radius-sm);\n    font-size: 12px;\n    font-weight: 700;\n    color: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-modal-submit:hover {\n    background: #4338ca;\n}\n\n.btn-modal-submit:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n}\n\n.btn-modal-delete {\n    padding: 7px 16px;\n    background: #ef4444;\n    border: 1px solid #ef4444;\n    border-radius: var(--radius-sm);\n    font-size: 12px;\n    font-weight: 700;\n    color: #ffffff;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.btn-modal-delete:hover {\n    background: #dc2626;\n}\n\n/* ==========================================================================\n   Split ticket details & project chat system\n   ========================================================================== */\n\n.ticket-chat-modal-dialog {\n    max-width: 1450px !important;\n    width: 96vw !important;\n    margin: 16px auto !important;\n}\n\n.ticket-chat-modal-content {\n    border-radius: 16px !important;\n    border: 1px solid #e2e8f0 !important;\n    box-shadow: 0 25px 60px -15px rgba(15, 23, 42, 0.28) !important;\n    background: #ffffff !important;\n    overflow: hidden !important;\n    display: flex !important;\n    flex-direction: column !important;\n    height: 86vh !important;\n    max-height: 870px !important;\n    min-height: 600px !important;\n}\n\n/* CRM Top Bar (Matching Lead Details UI) */\n.crm-modal-top-bar {\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    padding: 12px 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    flex-shrink: 0;\n    z-index: 10;\n}\n\n.crm-top-bar-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n}\n\n.crm-modal-icon-box {\n    width: 36px;\n    height: 36px;\n    border-radius: 9px;\n    background: #eff6ff;\n    color: #2563eb;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 17px;\n    flex-shrink: 0;\n    border: 1px solid #dbeafe;\n}\n\n.crm-title-group {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n}\n\n.crm-title-row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.crm-modal-title {\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    font-family: var(--font-heading);\n    margin: 0;\n    line-height: 1.2;\n}\n\n.crm-ref-badge-wrap {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    background: #f1f5f9;\n    padding: 2px 7px;\n    border-radius: 6px;\n    border: 1px solid #e2e8f0;\n}\n\n.crm-ref-code {\n    font-family: var(--font-mono, monospace);\n    font-size: 11px;\n    font-weight: 700;\n    color: #475569;\n    letter-spacing: 0.3px;\n}\n\n.btn-copy-ref {\n    background: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    font-size: 11px;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.15s ease;\n}\n\n.btn-copy-ref:hover {\n    color: #2563eb;\n}\n\n.crm-modal-sub {\n    font-size: 11.5px;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.crm-top-bar-right {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-shrink: 0;\n}\n\n\n.crm-status-pill {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 11.5px;\n    font-weight: 700;\n    text-transform: capitalize;\n}\n\n.crm-status-pill.status-open {\n    background: #eff6ff;\n    color: #1d4ed8;\n    border: 1px solid #bfdbfe;\n}\n\n.crm-status-pill.status-in_progress {\n    background: #fefce8;\n    color: #a16207;\n    border: 1px solid #fef08a;\n}\n\n.crm-status-pill.status-resolved {\n    background: #ecfdf5;\n    color: #047857;\n    border: 1px solid #a7f3d0;\n}\n\n.crm-status-pill.status-closed {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n}\n\n.crm-status-pill .status-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: currentColor;\n}\n\n.crm-priority-pill {\n    padding: 4px 12px;\n    border-radius: 20px;\n    font-size: 11.5px;\n    font-weight: 700;\n    letter-spacing: 0.2px;\n}\n\n.crm-priority-pill.priority-urgent,\n.crm-priority-pill.priority-high {\n    background: #f5f3ff;\n    color: #6d28d9;\n    border: 1px solid #ddd6fe;\n}\n\n.crm-priority-pill.priority-medium,\n.crm-priority-pill.priority-normal {\n    background: #eff6ff;\n    color: #1d4ed8;\n    border: 1px solid #bfdbfe;\n}\n\n.crm-priority-pill.priority-low {\n    background: #f1f5f9;\n    color: #475569;\n    border: 1px solid #cbd5e1;\n}\n\n.crm-modal-close-btn {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    border: 1px solid transparent;\n    background: transparent;\n    color: #64748b;\n    font-size: 15px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.crm-modal-close-btn:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n    border-color: #e2e8f0;\n}\n\n/* CRM Subnav Navigation Tabs */\n.crm-modal-subnav {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 0 24px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    flex-shrink: 0;\n}\n\n.crm-subnav-tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 9px 14px;\n    font-size: 12.5px;\n    font-weight: 600;\n    color: #64748b;\n    background: transparent;\n    border: none;\n    border-bottom: 2px solid transparent;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.crm-subnav-tab:hover {\n    color: #1e293b;\n}\n\n.crm-subnav-tab.active {\n    color: #2563eb;\n    border-bottom-color: #2563eb;\n    font-weight: 700;\n}\n\n.crm-subnav-badge {\n    background: #2563eb;\n    color: #ffffff;\n    font-size: 10px;\n    font-weight: 700;\n    padding: 1px 6px;\n    border-radius: 10px;\n}\n\n\n\n/* Two-column Split Wrapper: Gray outer container, padding, gap between two distinct cards, NO middle line! */\n.ticket-split-wrapper {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n    background: #f1f5f9;\n    padding: 16px 20px;\n    gap: 16px;\n}\n\n/* Left Card / \"Modal\": Standalone rounded white card with border & shadow */\n.ticket-details-pane {\n    flex: 0 0 46%;\n    max-width: 46%;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.pane-card-title-bar {\n    padding: 12px 18px;\n    border-bottom: 1px solid #e2e8f0;\n    font-size: 13px;\n    font-weight: 700;\n    color: #1e293b;\n    display: flex;\n    align-items: center;\n    background: #ffffff;\n    flex-shrink: 0;\n}\n\n.ticket-details-inner-scroll {\n    flex: 1;\n    overflow-y: auto;\n    padding: 16px 18px;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    scrollbar-width: none;\n    /* Hide scrollbar on Firefox */\n    -ms-overflow-style: none;\n    /* Hide scrollbar on IE/Edge */\n}\n\n.ticket-details-inner-scroll::-webkit-scrollbar {\n    display: none;\n    /* Hide scrollbar on Chrome/Safari/Brave */\n}\n\n.crm-field-card {\n    background: #ffffff;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.crm-field-card.subject-card {\n    padding-bottom: 8px;\n    border-bottom: 1px solid #f1f5f9;\n}\n\n.crm-field-label {\n    font-size: 10.5px;\n    font-weight: 700;\n    color: #94a3b8;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n}\n\n.crm-subject-heading {\n    font-family: var(--font-heading);\n    font-size: 15px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1.35;\n    margin: 0;\n    word-break: break-word;\n}\n\n.crm-attributes-grid {\n    display: flex;\n    flex-direction: column;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 10px;\n    overflow: hidden;\n}\n\n.crm-attr-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 14px;\n    border-bottom: 1px solid #edf2f7;\n    font-size: 12px;\n}\n\n.crm-attr-row:last-child {\n    border-bottom: none;\n}\n\n.attr-label {\n    color: #64748b;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.attr-value {\n    color: #0f172a;\n    font-weight: 600;\n    text-align: right;\n}\n\n.crm-mini-pill {\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 10.5px;\n    font-weight: 700;\n    text-transform: capitalize;\n}\n\n.crm-mini-pill.priority-urgent,\n.crm-mini-pill.priority-high {\n    background: #fef2f2;\n    color: #dc2626;\n    border: 1px solid #fecaca;\n}\n\n.crm-mini-pill.priority-medium,\n.crm-mini-pill.priority-normal {\n    background: #eff6ff;\n    color: #2563eb;\n    border: 1px solid #bfdbfe;\n}\n\n.crm-mini-pill.priority-low {\n    background: #f1f5f9;\n    color: #64748b;\n    border: 1px solid #e2e8f0;\n}\n\n.crm-desc-content {\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    padding: 10px 12px;\n}\n\n.crm-desc-text {\n    font-size: 12.5px;\n    line-height: 1.5;\n    color: #334155;\n    margin: 0;\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.crm-desc-empty {\n    font-size: 12px;\n    color: #94a3b8;\n    margin: 0;\n    font-style: italic;\n}\n\n.crm-att-count {\n    font-size: 11px;\n    color: #64748b;\n    font-weight: 600;\n    background: #f1f5f9;\n    padding: 1px 7px;\n    border-radius: 6px;\n    border: 1px solid #e2e8f0;\n}\n\n\n\n/* Modal Bottom Footer */\n.ticket-modal-bottom-footer {\n    background: #ffffff;\n    border-top: 1px solid #e2e8f0;\n    padding: 10px 24px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n}\n\n.footer-left {\n    display: flex;\n    align-items: center;\n    font-size: 11.5px;\n    color: #64748b;\n    font-weight: 500;\n}\n\n.footer-timestamp {\n    color: #64748b;\n    font-size: 11.5px;\n}\n\n.btn-footer-close {\n    padding: 5px 16px;\n    font-size: 12px;\n    font-weight: 600;\n    color: #475569;\n    background: #f8fafc;\n    border: 1px solid #cbd5e1;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.btn-footer-close:hover {\n    background: #f1f5f9;\n    color: #0f172a;\n    border-color: #94a3b8;\n}\n\n/* Screenshots Grid */\n.ticket-screenshots-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n    gap: 10px;\n}\n\n.ticket-screen-thumb-card {\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f8fafc;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.ticket-screen-thumb-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);\n    border-color: #cbd5e1;\n}\n\n.thumb-img-wrapper {\n    position: relative;\n    height: 70px;\n    width: 100%;\n    background: #0f172a;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.thumb-actual-img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: transform 0.2s ease;\n}\n\n.ticket-screen-thumb-card:hover .thumb-actual-img {\n    transform: scale(1.05);\n}\n\n.thumb-hover-overlay {\n    position: absolute;\n    inset: 0;\n    background: rgba(15, 23, 42, 0.55);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 3px;\n    color: #ffffff;\n    font-size: 11px;\n    font-weight: 600;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.thumb-hover-overlay i {\n    font-size: 16px;\n}\n\n.ticket-screen-thumb-card:hover .thumb-hover-overlay {\n    opacity: 1;\n}\n\n.thumb-caption {\n    padding: 6px 8px;\n    background: #ffffff;\n    border-top: 1px solid #f1f5f9;\n}\n\n.thumb-name {\n    display: block;\n    font-size: 10.5px;\n    font-weight: 600;\n    color: #475569;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.attachments-empty-card {\n    padding: 16px;\n    text-align: center;\n    color: #94a3b8;\n    font-size: 12px;\n    background: #f8fafc;\n    border: 1px dashed #cbd5e1;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n}\n\n/* Assigned PM Card */\n.ticket-pm-card {\n    background: linear-gradient(135deg, #f8fafc, #eff6ff);\n    border: 1px solid #dbeafe;\n    border-radius: 12px;\n    padding: 12px 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.pm-card-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.pm-avatar-wrap {\n    position: relative;\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #4f46e5, #4338ca);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 13px;\n    font-weight: 700;\n    box-shadow: 0 2px 6px rgba(79, 70, 229, 0.25);\n    flex-shrink: 0;\n}\n\n.pm-status-indicator {\n    position: absolute;\n    bottom: -1px;\n    right: -1px;\n    width: 10px;\n    height: 10px;\n    background: #10b981;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n}\n\n.pm-info-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.pm-name-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.pm-name {\n    font-size: 13px;\n    font-weight: 700;\n    color: #0f172a;\n}\n\n.pm-role-tag {\n    font-size: 10px;\n    font-weight: 700;\n    color: #2563eb;\n    background: #dbeafe;\n    padding: 1px 6px;\n    border-radius: 4px;\n}\n\n.pm-response-note {\n    font-size: 11px;\n    color: #64748b;\n    line-height: 1.4;\n}\n\n.ticket-pm-card {\n    background: linear-gradient(135deg, #f8fafc, #eff6ff);\n    border: 1px solid #dbeafe;\n    border-radius: 12px;\n    padding: 12px 14px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n/* Right Card / \"Modal\": Standalone rounded white card with border & shadow */\n.ticket-chat-pane {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 12px;\n    box-shadow: 0 1px 4px rgba(15, 23, 42, 0.04);\n    min-height: 0;\n    overflow: hidden;\n}\n\n/* Chat Header */\n.ticket-chat-header {\n    padding: 12px 20px;\n    background: #ffffff;\n    border-bottom: 1px solid #e2e8f0;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n}\n\n.chat-header-user {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.chat-pm-avatar {\n    position: relative;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: linear-gradient(135deg, #4f46e5, #6366f1);\n    color: #ffffff;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 14px;\n    box-shadow: 0 4px 10px rgba(79, 70, 229, 0.25);\n    flex-shrink: 0;\n}\n\n.chat-online-dot {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 11px;\n    height: 11px;\n    background: #10b981;\n    border: 2px solid #ffffff;\n    border-radius: 50%;\n}\n\n.chat-pm-info {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.chat-pm-title-row {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.chat-pm-title {\n    font-family: var(--font-heading);\n    font-size: 14px;\n    font-weight: 800;\n    color: #0f172a;\n}\n\n.chat-badge-admin {\n    font-size: 10px;\n    font-weight: 700;\n    color: #4f46e5;\n    background: #eef2ff;\n    padding: 2px 7px;\n    border-radius: 999px;\n    border: 1px solid #e0e7ff;\n}\n\n.chat-pm-status {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11.5px;\n    color: #64748b;\n}\n\n.pulse-dot-sm {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #10b981;\n    display: inline-block;\n    position: relative;\n}\n\n.pulse-dot-sm.emerald {\n    background: #10b981;\n    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n}\n\n.chat-workspace-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 4px 10px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #475569;\n}\n\n/* Chat Messages Wrap */\n.ticket-chat-messages-wrap {\n    flex: 1;\n    min-height: 0;\n    overflow-y: auto;\n    padding: 16px 20px;\n    background: #fafbfc;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    scrollbar-width: thin;\n    scrollbar-color: #cbd5e1 transparent;\n}\n\n.ticket-chat-messages-wrap::-webkit-scrollbar {\n    width: 5px;\n}\n\n.ticket-chat-messages-wrap::-webkit-scrollbar-thumb {\n    background: #cbd5e1;\n    border-radius: 4px;\n}\n\n.chat-intro-banner {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    padding: 10px 14px;\n    background: #eef2ff;\n    border: 1px solid #e0e7ff;\n    border-radius: 10px;\n}\n\n.intro-icon {\n    font-size: 16px;\n    color: #4f46e5;\n    margin-top: 1px;\n}\n\n.intro-text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 11.5px;\n    color: #3730a3;\n    line-height: 1.4;\n}\n\n.intro-text strong {\n    font-weight: 700;\n    color: #312e81;\n}\n\n.chat-date-separator {\n    text-align: center;\n    position: relative;\n    margin: 6px 0;\n}\n\n.chat-date-separator::before {\n    content: '';\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 50%;\n    height: 1px;\n    background: #e2e8f0;\n}\n\n.chat-date-separator span {\n    position: relative;\n    background: #ffffff;\n    padding: 2px 12px;\n    border-radius: 999px;\n    border: 1px solid #e2e8f0;\n    font-size: 10.5px;\n    font-weight: 600;\n    color: #94a3b8;\n}\n\n.chat-message-list {\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n}\n\n.chat-message-row {\n    display: flex;\n    gap: 10px;\n    max-width: 84%;\n    align-items: flex-end;\n}\n\n.chat-message-row.from-pm {\n    align-self: flex-start;\n}\n\n.chat-message-row.from-client {\n    align-self: flex-end;\n    flex-direction: row;\n}\n\n.msg-sender-avatar {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 11px;\n    font-weight: 700;\n    flex-shrink: 0;\n    margin-bottom: 4px;\n}\n\n.msg-sender-avatar.pm {\n    background: linear-gradient(135deg, #eef2ff, #e0e7ff);\n    color: #4f46e5;\n    border: 1px solid #c7d2fe;\n}\n\n.msg-sender-avatar.client {\n    background: #0f172a;\n    color: #ffffff;\n}\n\n.meta-avatar-xs {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    border-radius: 50%;\n    background: #eef2ff;\n    color: #4f46e5;\n    font-size: 10px;\n    font-weight: 700;\n    border: 1px solid #c7d2fe;\n}\n\n.meta-avatar-xs.rt-badge {\n    background: linear-gradient(135deg, #4f46e5, #6366f1);\n    color: #ffffff;\n    border: none;\n    box-shadow: 0 1px 3px rgba(79, 70, 229, 0.25);\n}\n\n.chat-pm-avatar.rt-avatar {\n    background: linear-gradient(135deg, #4f46e5, #6366f1);\n    color: #ffffff;\n}\n\n.chat-empty-thread {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 56px 20px;\n    margin: auto 0;\n}\n\n.chat-empty-icon-wrap {\n    width: 54px;\n    height: 54px;\n    border-radius: 50%;\n    background: #f1f5f9;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    margin-bottom: 14px;\n    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.05);\n}\n\n.chat-empty-title {\n    font-family: var(--font-heading);\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    margin-bottom: 6px;\n}\n\n.chat-empty-desc {\n    font-size: 12.5px;\n    color: #64748b;\n    max-width: 320px;\n    line-height: 1.5;\n    margin: 0;\n}\n\n.msg-bubble-container {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    min-width: 0;\n}\n\n.chat-message-row.from-client .msg-bubble-container {\n    align-items: flex-end;\n}\n\n.msg-meta-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 10.5px;\n    color: #94a3b8;\n    padding: 0 4px;\n}\n\n.msg-sender-label {\n    font-weight: 700;\n    color: #475569;\n}\n\n.msg-bubble {\n    padding: 10px 14px;\n    border-radius: 14px;\n    font-size: 12.5px;\n    line-height: 1.5;\n    word-break: break-word;\n    position: relative;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);\n}\n\n.bubble-pm {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    color: #1e293b;\n    border-bottom-left-radius: 4px;\n}\n\n.bubble-client {\n    background: linear-gradient(135deg, #4f46e5, #4338ca);\n    color: #ffffff;\n    border-bottom-right-radius: 4px;\n    box-shadow: 0 4px 14px rgba(79, 70, 229, 0.25);\n}\n\n.msg-bubble-text {\n    white-space: pre-wrap;\n}\n\n.msg-status-indicator {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 10.5px;\n    color: #94a3b8;\n    padding-right: 4px;\n}\n\n/* Chat Attachment Card */\n.msg-attachment-card {\n    margin-top: 8px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(255, 255, 255, 0.15);\n    border: 1px solid rgba(255, 255, 255, 0.25);\n    padding: 6px 10px;\n    border-radius: 8px;\n}\n\n.bubble-pm .msg-attachment-card {\n    background: #f8fafc;\n    border-color: #e2e8f0;\n}\n\n.attachment-icon {\n    font-size: 16px;\n}\n\n.attachment-details {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n\n.attachment-name {\n    font-size: 11px;\n    font-weight: 700;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 160px;\n}\n\n.attachment-size {\n    font-size: 10px;\n    opacity: 0.85;\n}\n\n.btn-view-att {\n    background: transparent;\n    border: none;\n    color: inherit;\n    cursor: pointer;\n    font-size: 13px;\n    padding: 2px 6px;\n    margin-left: auto;\n}\n\n.msg-screenshots-preview {\n    margin-top: 6px;\n    padding-top: 6px;\n    border-top: 1px solid rgba(255, 255, 255, 0.2);\n    font-size: 11px;\n    opacity: 0.9;\n}\n\n/* Typing Indicator */\n.typing-bubble {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    padding: 10px 14px;\n    min-width: 54px;\n}\n\n.typing-dot {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #6366f1;\n    animation: typingBounce 1.4s infinite ease-in-out both;\n}\n\n.typing-dot:nth-child(1) {\n    animation-delay: -0.32s;\n}\n\n.typing-dot:nth-child(2) {\n    animation-delay: -0.16s;\n}\n\n@keyframes typingBounce {\n\n    0%,\n    80%,\n    100% {\n        transform: scale(0);\n        opacity: 0.4;\n    }\n\n    40% {\n        transform: scale(1);\n        opacity: 1;\n    }\n}\n\n/* Quick Suggestions Chips */\n.chat-quick-suggestions {\n    padding: 6px 20px;\n    background: #ffffff;\n    border-top: 1px solid #f1f5f9;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.suggestions-label {\n    font-size: 10.5px;\n    font-weight: 700;\n    color: #94a3b8;\n    white-space: nowrap;\n}\n\n.suggestions-scroll {\n    display: flex;\n    gap: 6px;\n    overflow-x: auto;\n    padding-bottom: 2px;\n}\n\n.suggestions-scroll::-webkit-scrollbar {\n    display: none;\n}\n\n.btn-suggestion-chip {\n    padding: 3px 10px;\n    background: #f8fafc;\n    border: 1px solid #e2e8f0;\n    border-radius: 999px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #475569;\n    white-space: nowrap;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.btn-suggestion-chip:hover {\n    background: #eef2ff;\n    border-color: #c7d2fe;\n    color: #4f46e5;\n    transform: translateY(-1px);\n}\n\n/* Chat Input Area */\n.ticket-chat-input-area {\n    padding: 12px 20px 14px 20px;\n    background: #ffffff;\n    border-top: 1px solid #e2e8f0;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.chat-attachment-pending-bar {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 6px 10px;\n    background: #f1f5f9;\n    border: 1px solid #e2e8f0;\n    border-radius: 6px;\n}\n\n.pending-att-left {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11.5px;\n    color: #334155;\n    min-width: 0;\n}\n\n.pending-att-name {\n    font-weight: 600;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 260px;\n}\n\n.pending-att-size {\n    color: #64748b;\n    font-size: 10.5px;\n}\n\n.btn-remove-pending-att {\n    background: transparent;\n    border: none;\n    color: #ef4444;\n    cursor: pointer;\n    font-size: 13px;\n    padding: 0 4px;\n}\n\n.chat-input-form {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n}\n\n.btn-chat-action-tool {\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    background: #f8fafc;\n    color: #64748b;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n}\n\n.btn-chat-action-tool:hover {\n    background: #eef2ff;\n    color: #4f46e5;\n    border-color: #c7d2fe;\n}\n\n.chat-input-field {\n    flex: 1;\n    height: 38px;\n    padding: 8px 14px;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 12.5px;\n    color: #1e293b;\n    background: #f8fafc;\n    outline: none;\n    transition: all 0.2s ease;\n}\n\n.chat-input-field:focus {\n    background: #ffffff;\n    border-color: #4f46e5;\n    box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);\n}\n\n.btn-chat-send-submit {\n    height: 38px;\n    padding: 0 16px;\n    background: linear-gradient(135deg, #4f46e5, #4338ca);\n    color: #ffffff;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    box-shadow: 0 3px 10px rgba(79, 70, 229, 0.3);\n    transition: all 0.15s ease;\n    flex-shrink: 0;\n}\n\n.btn-chat-send-submit:hover:not(:disabled) {\n    background: linear-gradient(135deg, #4338ca, #3730a3);\n    transform: translateY(-1px);\n    box-shadow: 0 5px 14px rgba(79, 70, 229, 0.4);\n}\n\n.btn-chat-send-submit:disabled {\n    background: #cbd5e1;\n    cursor: not-allowed;\n    box-shadow: none;\n}\n\n.chat-input-helper-note {\n    font-size: 10.5px;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n}\n\n/* ==========================================================================\n   Screenshot / Image Preview Lightbox (Premium, High Contrast, Frosted Blur)\n   ========================================================================== */\n\n.support-img-preview-backdrop {\n    z-index: 1065 !important;\n    background-color: rgba(10, 15, 30, 0.8) !important;\n    backdrop-filter: blur(8px) !important;\n    -webkit-backdrop-filter: blur(8px) !important;\n}\n\n.support-img-preview-dialog {\n    z-index: 1070 !important;\n    max-width: 1100px !important;\n    width: 94vw !important;\n    margin: 24px auto !important;\n}\n\n.support-img-preview-content {\n    background: #0f172a !important;\n    border-radius: 16px !important;\n    border: 1px solid rgba(255, 255, 255, 0.12) !important;\n    box-shadow: 0 25px 65px -12px rgba(0, 0, 0, 0.65) !important;\n    overflow: hidden !important;\n    display: flex !important;\n    flex-direction: column !important;\n}\n\n.support-img-preview-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 14px 22px;\n    background: #1e293b;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n    gap: 16px;\n    flex-shrink: 0;\n}\n\n.preview-header-left {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.preview-icon-box {\n    width: 36px;\n    height: 36px;\n    border-radius: 9px;\n    background: rgba(99, 102, 241, 0.15);\n    color: #818cf8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 17px;\n    border: 1px solid rgba(99, 102, 241, 0.3);\n    flex-shrink: 0;\n}\n\n.preview-title-group {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.preview-modal-title {\n    font-family: var(--font-heading);\n    font-size: 15px;\n    font-weight: 700;\n    color: #f8fafc;\n    margin: 0;\n    line-height: 1.2;\n}\n\n.preview-modal-subtitle {\n    font-size: 11.5px;\n    color: #94a3b8;\n    font-weight: 500;\n}\n\n.preview-header-right {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.btn-preview-tool {\n    display: inline-flex;\n    align-items: center;\n    padding: 6px 14px;\n    background: rgba(255, 255, 255, 0.08);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 7px;\n    color: #f1f5f9;\n    font-size: 12px;\n    font-weight: 600;\n    text-decoration: none;\n    transition: all 0.15s ease;\n}\n\n.btn-preview-tool:hover {\n    background: rgba(255, 255, 255, 0.16);\n    color: #ffffff;\n    border-color: rgba(255, 255, 255, 0.3);\n    text-decoration: none;\n    transform: translateY(-1px);\n}\n\n.btn-preview-close {\n    width: 32px;\n    height: 32px;\n    border-radius: 7px;\n    background: rgba(255, 255, 255, 0.08);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    color: #cbd5e1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: 14px;\n    transition: all 0.15s ease;\n}\n\n.btn-preview-close:hover {\n    background: #ef4444;\n    border-color: #ef4444;\n    color: #ffffff;\n    transform: translateY(-1px);\n}\n\n.support-img-preview-body {\n    padding: 24px;\n    background: #090d16;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 360px;\n    max-height: 78vh;\n    overflow: auto;\n}\n\n.preview-img-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-width: 100%;\n}\n\n.preview-display-img {\n    max-width: 100%;\n    max-height: 72vh;\n    object-fit: contain;\n    display: block;\n    border-radius: 8px;\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n@media (max-width: 992px) {\n    .support-kpi-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 10px;\n    }\n\n    .support-table th,\n    .support-table td {\n        padding: 10px 12px;\n    }\n}\n\n@media (max-width: 768px) {\n    .support-tickets-card .pro-card-header {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n        padding: 12px 14px;\n    }\n\n    .card-header-actions {\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n\n    .support-search-wrap {\n        width: 100% !important;\n    }\n\n    .custom-popover-dropdown {\n        flex: 1;\n        min-width: 130px;\n    }\n\n    .custom-dropdown-btn {\n        width: 100%;\n        justify-content: space-between;\n    }\n\n    .table-responsive {\n        -webkit-overflow-scrolling: touch;\n        overflow-x: auto;\n        width: 100%;\n    }\n\n    .support-table {\n        min-width: 780px;\n    }\n}\n\n@media (max-width: 576px) {\n    .support-kpi-grid {\n        grid-template-columns: 1fr;\n        gap: 8px;\n    }\n\n    .support-kpi-card {\n        padding: 12px 14px;\n        gap: 12px;\n    }\n\n    .support-kpi-val {\n        font-size: 18px;\n    }\n\n    .custom-popover-dropdown {\n        flex: 1 1 calc(50% - 4px);\n        min-width: 110px;\n    }\n\n    .date-range-popover {\n        position: fixed !important;\n        left: 14px !important;\n        right: 14px !important;\n        top: 50% !important;\n        transform: translateY(-50%) !important;\n        min-width: auto !important;\n        width: auto !important;\n        max-width: calc(100vw - 28px) !important;\n        box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.35) !important;\n        z-index: 1050 !important;\n    }\n\n    .screenshot-preview-grid {\n        grid-template-columns: repeat(3, 1fr);\n        gap: 6px;\n    }\n\n    .custom-support-modal .modal-body {\n        padding: 16px 14px;\n    }\n\n    .custom-support-modal .modal-header {\n        padding: 12px 16px;\n    }\n\n    .custom-support-modal .modal-footer {\n        padding: 10px 14px;\n        flex-direction: column;\n        gap: 8px;\n    }\n\n    .custom-support-modal .btn-modal-cancel,\n    .custom-support-modal .btn-modal-submit,\n    .custom-support-modal .btn-modal-delete {\n        width: 100%;\n        justify-content: center;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
